export default "__VITE_ASSET__2456dbbb__"